// 手机号
export const REGEX_PHONE = /^[1][3-9]\d{9}$/

// 车牌
export const REGEX_LPN = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]([A-HJ-NP-Z0-9])[0-9]{4})|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳领]{1})))$/

// 中石化加油卡号
export const ZSH_REGEX_OIL = /^100011\d{13}$/

// 中石油加油卡号
export const ZSY_REGEX_OIL = /^90\d{14}$/

//手机号
export const MobileRegExp = /^1\d{10}$/;
